// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-screens-Group-Create-_FZTF0","formContainer":"styles-module__formContainer__src-labstep-web-screens-Group-Create-_UqybN"};